import { Rectangle, Tooltip } from 'react-leaflet'
import { HeatmapPoint } from '@api/endpoints/marketing'
import { intensityColor } from './intensity'

interface GridCellLayerProps {
  points: HeatmapPoint[]
  maxWeight: number
  tier: string
  /** True when the current frame is a single 30-min window (count = unique users);
   *  false when summed across windows (count = visits/activity). */
  perWindow: boolean
}

/**
 * Draws each geohash cell as a rectangle matching its real bounds, shaded by
 * visitor count, with a hover tooltip showing the exact numbers. Unlike the
 * smooth heat layer, cells tile the grid exactly so there are no gaps and the
 * per-cell count is readable.
 */
export function GridCellLayer({ points, maxWeight, tier, perWindow }: GridCellLayerProps) {
  const noun = perWindow ? 'unique users' : 'visits'
  const label = tier === 'all' ? noun : `${tier} ${noun}`
  return (
    <>
      {points.map((p, i) => (
        <Rectangle
          key={i}
          bounds={[
            [p.south, p.west],
            [p.north, p.east],
          ]}
          pathOptions={{
            color: '#444',
            weight: 1,
            fillColor: intensityColor(p.weight, maxWeight),
            fillOpacity: 0.65,
          }}
        >
          <Tooltip sticky>
            <div style={{ lineHeight: 1.4 }}>
              <strong>{p.weight.toLocaleString()}</strong> {label}
              <br />
              <span style={{ opacity: 0.75 }}>
                Free {p.free} · Basic {p.basic} · Premium {p.premium}
              </span>
            </div>
          </Tooltip>
        </Rectangle>
      ))}
    </>
  )
}
